
import { Link } from 'react-router-dom';

export default function MarketCTA() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/20dd48df2ea7635d35b7acc59c4fe04e.jpg')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-['Montserrat']">
          Join the Global Chrome Trade Network
        </h2>
        <p className="text-xl text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed font-['Lato']">
          Whether you&apos;re looking to source premium chrome products or explore partnership opportunities, TMI is your trusted gateway to South Africa&apos;s chrome market.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link
            to="/contact"
            className="bg-[#8B1538] text-white px-10 py-4 rounded-lg font-medium hover:bg-[#6B0F2A] transition-colors whitespace-nowrap cursor-pointer text-lg"
          >
            Request a Quote
          </Link>
          <Link
            to="/mining"
            className="bg-white/10 backdrop-blur-sm border border-white/30 text-white px-10 py-4 rounded-lg font-medium hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer text-lg"
          >
            View Our Operations
          </Link>
        </div>
      </div>
    </section>
  );
}
